import { isEmpty } from "lodash"

class SubscriptionModel {
  constructor(clientDetails, selectedPlans, userType) {
    this.clientDetails = clientDetails
    this.selectedPlans = selectedPlans
    this.userType = userType
    this.errors = {}
  }

  isValidUrl(string) {
    let url

    try {
      url = new URL(string)
    } catch (_) {
      return false
    }

    return url.protocol === "http:" || url.protocol === "https:"
  }

  validateNewSubscription() {
    if (this.userType === "visitor") {
      const checkPresenceFields = [
        "firstName",
        "lastName",
        "clientDesignation",
        "email",
        "clientPhoneNumber",
        "companyName",
        "companyUen",
        "companyWebsite",
        "companyStaffsStrength",
      ]

      checkPresenceFields.map((field) => {
        if (isEmpty(this.clientDetails[field])) {
          if (isEmpty(this.errors[field])) this.errors[field] = "Field required"
        }
      })

      // Validate email format
      const emailRegex = new RegExp(/[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/gim)

      if (
        isEmpty(this.errors.email) &&
        !emailRegex.test(this.clientDetails.email)
      ) {
        this.errors.email = "Wrong email format"
      }

      // Validate phone number
      if (isEmpty(this.errors.clientPhoneNumber)) {
        if (
          this.clientDetails.clientPhoneNumber.length > 0 &&
          this.clientDetails.clientPhoneNumber.length < 8
        ) {
          this.errors.clientPhoneNumber = "Must be at least 8 digits"
        } else if (
          this.clientDetails.clientPhoneNumber.length > 0 &&
          !/^[+]?\d+$/g.test(this.clientDetails.clientPhoneNumber)
        ) {
          this.errors.clientPhoneNumber = "Wrong phone number format"
        }
      }

      // Validate company website
      if (!this.isValidUrl(this.clientDetails.companyWebsite)) {
        this.errors.companyWebsite =
          "Not a valid website URL (e.g. https://www.google.com)"
      } else if (!this.clientDetails.companyWebsite) {
        this.errors.companyWebsite = "Required"
      }
    }
  }
}

export default SubscriptionModel
